/*
 * Copyright (c) 2020  Apricad LLC. All Rights Reserved.
 */

import { createSelector } from "reselect";
import { studyData } from "client/reducers/studyReducer";

// --- for Study Data ---
// ----------------------------------------------------------------------

// Function to retrieve piece of state
const dataItemType = (state: any, type: number) => type;
const dataStudy = (state: any) => state.state_study;

// Selector consumed by components consuming
export const selectorStudy = createSelector([dataStudy], (study) => study);

// Selector consumed by action creator to check if the specified study item is loaded
export const studyLoaded = createSelector(
  [dataItemType, dataStudy],
  (type, study) => study && study[studyData[type]],
);
